/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author       Afternet <info@afternet.gr>
 *  @copyright Afternet
 *  @license      http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export default class subCategoriesSlider{
    init (){
        if($('.js-subCategories-slider').length){

            var swiper = new Swiper(".js-subCategories-slider", {
                slidesPerView: "auto",
                freeMode: true,
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                spaceBetween: 20,
                // pagination: {
                //     el: ".js-subCategories-slider-pagination",
                //     clickable: true,
                // },
            });

        }
    }
}